export type VariableContext = {
  providerName?: string;
  providerFirstName?: string;
  providerLastName?: string;
  providerTitle?: string;
  providerSuffix?: string;
  providerSpeciality?: string;
  providerRoomURL?: string;
  providerEmail?: string;
  staffEmail?: string;
  staffAvatar?: string;
  organizationName?: string;
  clientLabel?: string;
  participantName?: string;
};

type Resolver = (ctx: VariableContext) => string | undefined;

export const VARIABLE_REGISTRY: Record<string, Resolver> = {
  providerName: (ctx) => ctx.providerName,
  providerFirstName: (ctx) => ctx.providerFirstName,
  providerLastName: (ctx) => ctx.providerLastName,
  providerTitle: (ctx) => ctx.providerTitle,
  providerSuffix: (ctx) => ctx.providerSuffix,
  providerSpeciality: (ctx) => ctx.providerSpeciality,
  providerRoomURL: (ctx) => ctx.providerRoomURL,
  providerEmail: (ctx) => ctx.providerEmail,
  staffEmail: (ctx) => ctx.staffEmail,
  staffAvatar: (ctx) => ctx.staffAvatar,
  organizationName: (ctx) => ctx.organizationName,
  clientLabel: (ctx) => ctx.clientLabel ?? 'Patient',
  participantName: (ctx) => ctx.participantName,
};

export const VARIABLE_PREVIEW_CONTEXT: VariableContext = {
  providerName: 'Dr. Sample Provider, LCSW',
  providerFirstName: 'Sample',
  providerLastName: 'Provider',
  providerSuffix: 'LCSW',
  providerTitle: 'Dr.',
  providerSpeciality: 'General Practice',
  providerRoomURL: 'https://hipaalink.net/roomurl',
  providerEmail: 'provider@clinic.com',
  staffEmail: 'provider@clinic.com',
  organizationName: 'Sample Clinic',
  clientLabel: 'Patient',
  participantName: 'John Doe',
};

export function injectVariables(text: string, ctx: VariableContext): string {
  if (!text) return text;
  return text.replace(/\{(\w+)\}/g, (match, key: string) => {
    const resolver = VARIABLE_REGISTRY[key];
    if (!resolver) return match;
    return resolver(ctx) ?? '';
  });
}
